<template>
    <div class="MainWrapper">
        <Transition
            name="fade"
            mode="out-in"
        >
            <WLoading
                v-if="isLoading"
                key="loading"
                visible
                :opacity="1"
                position="absolute"
                :text="$t('general.loading')"
            />
            <div
                v-else-if="isAuth"
                key="main"
            >
                <Notification
                    group="global"
                    position="bottom left"
                />
                <TheModal />
                <div
                    class="MainContainer"
                    :class="{
                        hidden: isHidden
                    }"
                >
                    <Transition
                        name="main-router"
                        mode="out-in"
                        @beforeEnter="enableHidden"
                        @beforeLeave="enableHidden"
                        @afterLeave="disableHidden"
                        @afterEnter="disableHidden"
                    >
                        <RouterView />
                    </Transition>
                </div>
            </div>
            <RouterView
                v-else
                key="router"
            />
        </Transition>
    </div>
</template>

<script>
import {
    mapGetters,
} from 'vuex'
import { TheModal, Notification } from '@/components'

export default {
    name: 'Main',
    components: {
        TheModal,
        Notification,
    },
    data () {
        return {
            isHidden: false,
        }
    },
    computed: {
        ...mapGetters({
            isLoading: 'system/isLoading',
            isAuth: 'auth/isAuth',
        }),
    },
    methods: {
        enableHidden () {
            this.isHidden = true
        },
        disableHidden () {
            this.isHidden = false
        },
    },
}
</script>

<style lang="scss">
@import '@/theme/theme.scss';

.MainContainer {
    min-height: 100vh;

    &.hidden {
        overflow: hidden;
    }
}
</style>
